import styled, { css } from "styled-components";
import { ToggleIconWrapper } from "../globals/IconWrapper";
import { theme } from "../theme/toyotaTheme";
import * as CashPrice from "./price/CashPrice";
import * as BasketList from "./basket/BasketList";

export const ToggleIcon = styled(ToggleIconWrapper)`
    margin: 20px 0;
`;

export const HeaderToggle = styled.button<{ isCollapsible?: boolean }>`
    display: flex;
    flex: 1;
    flex-direction: row;
    width: 100%;
    margin-top: ${theme.space[1]}px;
    ${({ isCollapsible }) =>
        isCollapsible &&
        css`
            cursor: pointer;
        `};
`;

export const HeaderToggleInner = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: ${theme.space[1]}px 0;
    border-bottom: 1px solid ${({ isOpen }) => (isOpen ? "transparent" : theme.colors.grey2)};

    /* Align height (center) in HeaderToggleInner */
    ${CashPrice.Text} {
        position: relative;
        top: -2px;
    }
`;

export const ContentWrapper = styled.div`
    padding-bottom: ${theme.space[2]}px;
    border-bottom: 1px solid ${theme.colors.grey2};

    ${BasketList.BasketList} {
        padding: ${theme.space[1]}px ${theme.space[2]}px;
        background-color: ${theme.colors.grey1};
    }
`;

export const HeaderToggleTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    margin-right: auto;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;

    span {
        margin-right: 4px;
    }

    html[dir="rtl"] & {
        span {
            margin-left: 4px;
            margin-right: 0;
        }
    }
`;
